import axios from "axios";
import { getWebToken } from "../utils/tokenUtils";

const BASE_URL = process.env.REACT_APP_API_URL ?? "https://service.mutfacikservices.com/api/";

export const configWithoutToken = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {
    token:
      "eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoibXV0ZmFjaWt3ZWJzZXJ2aWNlIiwidHlwIjoiIiwibmJmIjoxNzI1MjExOTI4LCJleHAiOjE3MzAzOTU5MjgsImlzcyI6IllvdXJJc3N1ZXIiLCJhdWQiOiJZb3VyQXVkaWVuY2UifQ.p2Yi5e-CJklA2swJc-DT7jfjbAJpOyhw78xiEb2BUFc",
  },
});

export const configWithWebToken = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});
configWithWebToken.interceptors.request.use((config) => {
  const token = getWebToken();
  if (token) config.headers.Authorization = `Bearer ${token.token}`;
  return config;
});
